<div class="np-rows np-charge-rows" data-testid="nav-plan-charge-container">
  <div class="np-plan-rows-outer">
    <div class="np-row">
      <div class="np-pill">
        <img class="np-pill-icon" src="/assets/icons/dark/ui/chargingplan_lightning_icon.svg" />
        <span class="np-pill-value">
          <span class="np-num">{{ arrivedChargerDetails?.BatteryMinPercent }}</span>
          <span class="np-unit np-arrow">→</span>
          <span class="np-num">{{ arrivedChargerDetails?.BatteryMaxPercent }}</span>
          <span class="np-unit">%</span>
        </span>
      </div>
      <div class="np-pill charge-time-pill">
        <img class="np-pill-icon" src="/assets/icons/dark/ui/computer_icon_clock.svg" />
        <span class="np-pill-value">
          @for (part of chargeTimeParts; track $index) {
          @if (part.isUnit) {
          <span class="np-unit">{{ part.text }}</span>
          } @else {
          <span class="np-num">{{ part.text }}</span>
          }
          }
        </span>
      </div>
    </div>
  </div>
  <div class="np-actions" (click)="$event.stopPropagation()" data-testid="nav-plan-charge-actions-container">
    @if (chargeState == ChargeState.ArriveToCharger) {
    <button class="ev-button primary" (click)="onStartCharge()" data-testid="nav-plan-charge-charge-btn">
      {{ languageService.languageJSON.TurnList_CHARGE }}
    </button>
    @if (!arrivedChargerIsEndpoint) {
    <button class="ev-button" (click)="onReplanNavigation()" data-testid="nav-plan-charge-replan-btn">
      {{ languageService.languageJSON.Global_Replan }}
    </button>
    }
    @if (arrivedChargerIsEndpoint) {
    <button class="ev-button" (click)="onStopNavigation()" data-testid="nav-plan-charge-stop-btn">
      {{ languageService.languageJSON.Global_Stop }}
    </button>
    }
    }
    @if (chargeState == ChargeState.Charging || chargeState == ChargeState.ChargeFinish) {
    <button class="ev-button primary" (click)="onFinishCharge()" data-testid="nav-plan-charge-finish-btn">
      {{ languageService.languageJSON.NavigationHud_ChargingIsFinished }}
    </button>
    }
  </div>
</div>